<template>
  <div class="my-toast" :style="{ zIndex: zIndex }" @click.stop="bindCancel">
    <div class="toast" @click.stop>
      <img class="image" v-if="image" :src="image" alt="" />
      <div class="toast-title" v-html="title"></div>
      <div class="toast-desc" v-html="desc"></div>
      <div
        class="toast-btn"
        :style="{ background: confirmBackground }"
        @click="bindClick"
        >{{ confirmText }}</div
      >
    </div>
    <div class="close iconfont icon-cha"></div>
  </div>
</template>
<script>
export default {
  props: {
    zIndex: {
      type: Number | String,
      default: '2000'
    },
    title: {
      type: String,
      default: '提示'
    },
    desc: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    image: {
      type: String,
      default: ''
    },
    confirmBackground: {
      type: String,
      default: 'linear-gradient(180deg, #FEE1C3 0%, #FFCFA2 100%)'
    }
  },
  data() {
    return {}
  },
  methods: {
    bindClick() {
      this.$emit('confirm')
    },
    bindCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.my-toast {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  z-index: 99;

  .toast {
    text-align: center;
    width: 295px;
    padding: 20px;
    border-radius: 10px;
    box-sizing: border-box;
    background: #ffffff;

    .image {
      margin: 0 auto;
      width: 132px;
      height: 132px;
      object-fit: contain;
      margin-bottom: 7px;
    }

    .toast-title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 25px;
    }

    .toast-desc {
      margin-top: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.6);
      line-height: 24px;
    }

    .toast-btn {
      margin-top: 30px;
      height: 44px;
      line-height: 44px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      border-radius: 12px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #5c311f;
    }
  }
  .close {
    width: 24px;
    height: 24px;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
  }
}
</style>
